<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.44631 2.78859C7.56867 2.48487 7.86493 2.28571 8.19438 2.28571H13.3648C13.9348 2.28571 14.3246 2.85733 14.1129 3.38282L10.1535 13.2114C10.0311 13.5151 9.73486 13.7143 9.40541 13.7143H4.23496C3.66496 13.7143 3.27519 13.1427 3.48689 12.6172L7.44631 2.78859Z"
      fill="url(#paint0_linear_6092_4159)"
    />
    <path
      d="M5.25718 9.14285C7.15073 9.14285 8.68576 7.60783 8.68576 5.71428C8.68576 3.82073 7.15073 2.28571 5.25718 2.28571C3.36364 2.28571 1.82861 3.82073 1.82861 5.71428C1.82861 7.60783 3.36364 9.14285 5.25718 9.14285Z"
      fill="#0A33FF"
    />
    <path
      d="M8.68574 5.71429C8.68574 7.60783 7.15072 9.14286 5.25717 9.14286C5.1346 9.14286 5.01353 9.13643 4.89429 9.12388L7.35911 3.0054C8.16634 3.63267 8.68574 4.61282 8.68574 5.71429Z"
      fill="url(#paint1_linear_6092_4159)"
    />
    <defs>
      <linearGradient id="paint0_linear_6092_4159" x1="10.9297" y1="2.28571" x2="6.88934" y2="13.7282" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FFD60A" />
        <stop offset="1" stop-color="#F0BA09" />
      </linearGradient>
      <linearGradient id="paint1_linear_6092_4159" x1="7.33412" y1="3.00962" x2="4.88539" y2="9.11293" gradientUnits="userSpaceOnUse">
        <stop stop-color="#051A80" />
        <stop offset="1" stop-color="#0A33FF" />
      </linearGradient>
    </defs>
  </svg>
</template>
